import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { UPDATE_LISTINGS_FAILURE } from 'modules/authorizations/store/types/homesaleTypes';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { showToast } from 'modules/layout/layout.actions';
import { getHomesaleInfo, updateEquity } from 'modules/authorizations/store/actions/homesale.actions';
import EditableCard from 'modules/common/editableCard.component';
import React, { useState } from 'react';

const EquityDetailsCard = props => {
  const [isLoading, setIsLoading] = useState(false);
  // const [isLoadingButton, setIsLoadingButton] = useState(false);

  const { equity, isReadOnly, saleTypesEnum, equityStatusesEnum, version, fileId } = props;
  const equityInfo = equity ? equity.equityInfo : null;

  const tabs = [{ header: 'Equity Details', order: 1, iconPath: ['fas', 'money-check-dollar'] }];

  const typeOptions =
    saleTypesEnum && saleTypesEnum.length > 0
      ? saleTypesEnum.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const equityStatuses =
    equityStatusesEnum && equityStatusesEnum.length > 0
      ? equityStatusesEnum.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const summaries = [
    {
      header: 'Version',
      accessorKey: 'version',
      type: 'number',
      required: false,
      hideInModal: true,
      value: version,
      tab: 1
    },
    {
      header: 'Record Type',
      accessorKey: 'equityRecordType',
      type: 'dropdown',
      options: ['P', 'S'],
      required: false,
      disabled: true,
      value: equityInfo ? equityInfo.equityRecordType : 'P',
      tab: 1
    },
    {
      header: 'Posted',
      accessorKey: 'postedOn',
      type: 'date',
      required: false,
      hideInModal: true,
      value: equityInfo ? equityInfo.addedOn : '',
      tab: 1
    },
    {
      header: 'Sale Type',
      accessorKey: 'saleTypeId',
      type: 'dropdown-v2',
      required: false,
      options: typeOptions,
      value: equityInfo ? equityInfo.saleTypeId : '',
      tab: 1
    },
    {
      header: 'Prorate Date',
      accessorKey: 'prorationDate',
      type: 'date',
      required: false,
      value: equityInfo ? equityInfo.prorationDate : '',
      tab: 1
    },
    {
      header: 'Equity Type',
      accessorKey: 'equityStatusId',
      type: 'dropdown-v2',
      options: equityStatuses,
      required: false,
      value: equityInfo ? equityInfo.equityStatusId : '',
      tab: 1
    },
    {
      header: 'Closing',
      accessorKey: 'closingDate',
      type: 'date',
      required: false,
      value: equityInfo ? equityInfo.closingDate : '',
      tab: 1
    },
    {
      header: 'Purchase Price',
      accessorKey: 'purchaseSalePrice',
      type: 'money',
      required: false,
      value: equityInfo ? equityInfo.purchaseSalePrice : '',
      tab: 1
    },
    {
      header: 'Equity Total (MRES)',
      accessorKey: 'equityTotal',
      type: 'money',
      required: false,
      disabled: true,
      value: equityInfo ? equityInfo.equityTotal : '',
      tab: 1
    },
    { dividerLine: true, tab: 1 },
    {
      header: 'Comment',
      accessorKey: 'equityComments',
      type: 'notes',
      required: false,
      value: equityInfo ? equityInfo.equityComments : '',
      showBelow: true,
      tab: 1
    }
  ];

  const updateFields = async (tab, values) => {
    setIsLoading(true);

    let newValues = { ...equityInfo };
    newValues.saleTypeId = values.saleTypeId;
    newValues.prorationDate = values.prorationDate === '' ? null : values.prorationDate;
    newValues.equityStatusId = values.equityStatusId;
    newValues.closingDate = values.closingDate === '' ? null : values.closingDate;
    newValues.purchaseSalePrice = values.purchaseSalePrice;
    newValues.equityComments = values.equityComments;
    newValues.equityRecordType = values.equityRecordType === '' ? 'P' : values.equityRecordType;
    const resp = await props.updateEquity(fileId, newValues);
    if (resp.type === UPDATE_LISTINGS_FAILURE) {
      props.showToast('Failed to update equity info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return false;
    } else {
      await props.getHomesaleInfo(fileId);
      setIsLoading(false);
      return true;
    }
  };

  return (
    <EditableCard
      tabs={tabs}
      summaries={summaries}
      numColumns={5}
      updateFields={updateFields}
      isLoading={isLoading}
      // ButtonComponent={equityDetailsButtons}
      hideEdit={isReadOnly}
    />
  );
};

const mapStateToProps = state => {
  const { saleTypes, equityStatuses } = state.enumerations.allEnums;
  return {
    saleTypesEnum: saleTypes,
    equityStatusesEnum: equityStatuses
  };
};

export default compose(
  connect(mapStateToProps, {
    updateEquity,
    showToast,
    getHomesaleInfo
  })
)(EquityDetailsCard);
